<template>
  <div id="mtm-configurator">
    <form
      id="add-to-cart-form"
      method="POST"
      :action="'/checkout/cart/add/' + bagistoProductId"
    >
      <input type="hidden" name="results" :value="JSON.stringify(results)" />
      <input type="hidden" name="_token" :value="csrf" />
      <input type="hidden" name="is_buy_now" value="1" />
      <input type="hidden" name="product_id" :value="bagistoProductId" />
      <input type="hidden" name="quantity" value="1" />
      <input id="cnf_id" type="hidden" name="configuration_id" value="852" />
    </form>
    <div id="loader" v-if="showLoader">
      <div>
        <img width="200px" src="/configurator/loader-new.gif" />
      </div>
    </div>
    <div class="main-menu-overlay" :class="{ visible: showMenu }">
      <div class="main-menu" :class="{ opened: showMenu }">
        <div class="menu-wrapper">
          <div class="menu-logo">
            <img
              src="https://passoni.com/themes/passoni/assets/images/icons/logo-brand.svg"
              alt="Logo Passoni"
            />
          </div>
          <div class="head-block">
            <ul>
              <li v-if="this.loggedUser != null">
                <a href="#">Save configuration</a>
              </li>
              <li v-if="loggedUser != null" v-b-modal.retrieve-configuration>
                <a href="#">Retrieve configuration</a>
              </li>
              <li v-else>
                <a href="#" v-b-modal.login-modal>Login</a>
              </li>
              <li><a href="/en/knowledge-hub">Help &amp; Support</a></li>
              <li><a href="/en/contact">Contact Passoni</a></li>
              <li v-if="loggedUser != null" v-on:click="logout">
                <a href="#">Logout</a>
              </li>
            </ul>
          </div>
          <div class="tail-block">
            <ul>
              <li>
                <a href="https://passoni.com">Visit main passoni site</a>
              </li>
            </ul>
          </div>
          <div class="close-menu" v-on:click="showMenu = false">
            <img
              src="https://passoni.com/themes/passoni/assets/images/icons/close-menu.svg"
              alt="Close menu"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="header d-flex justify-content-between align-items-center">
      <div class="d-flex menu-area" style="gap: 20px; align-items: center">
        <div class="menu-icon">
          <img
            src="https://passoni.com/themes/passoni/assets/images/icons/menu.png"
            alt="Apri menu"
            class="icons-dark"
            v-on:click="showMenu = true"
          />
        </div>

        <a
          v-if="
            (currentPhase == 'selection' && currentSubPhase == 1) ||
            currentPhase == 'configuration' ||
            currentPhase == 'summary'
          "
          role="button"
          style="
            cursor: pointer;
            text-transform: uppercase;
            letter-spacing: 1.5px;
            font-size: 10px;
          "
          class="header-configure-another-bike"
          v-on:click="configureAnotherBike"
        >
          Configure another
        </a>
      </div>
      <div class="logo-wrapper">
        <a href="/configurator/">
          <img src="/configurator/logo.svg" alt="Logo Passoni" class="passoni-logo" />
        </a>
      </div>
      <div class="loaders">
        <a v-b-modal.retrieve-configuration style="cursor: pointer"
          >RETRIEVE CONFIGURATION</a
        >
      </div>
    </div>

    <section class="container-fluid px-5">
      <configuration-modal
        :loggedUser="loggedUser"
        :loginEmailState="loginEmailState"
        :loginEmail="loginEmail"
        :loginPasswordState="loginPasswordState"
        :loginPassword="loginPassword"
        :loggedUserConfigurations="loggedUserConfigurations"
        :bikes="bikes"
        v-on:set-login-email="setLoginEmail"
        v-on:set-login-password="setLoginPassword"
        v-on:set-login-res="(e) => (this.loggedUserConfigurations = e)"
        v-on:login="login"
        v-on:save-configuration="saveConfiguration"
      >
      </configuration-modal>
      <save-modal
        :loginEmail="loginEmail"
        :selectedDealer="selectedDealer"
        v-on:set-login-email="setLoginEmail"
        v-on:save-configuration="saveConfigurationAjax"
        v-on:set-error="setError"
        v-on:set-selected-dealer="setSelectedDealer"
        :confirmDisabled="confirmDisabled"
      ></save-modal>
      <login-modal
        :loginEmail="loginEmail"
        :loginPassword="loginPassword"
        :loggedUser="loggedUser"
        v-on:set-login-email="setLoginEmail"
        v-on:set-login-password="setLoginPassword"
        v-on:login="login"
        v-on:set-error="setError"
      ></login-modal>
      <buy-modal v-on:add-to-cart="addToCart"></buy-modal>

      <div
        class="main-content"
        :class="{
          'full-height':
            this.currentPhase == 'intro' || this.currentPhase == 'questionaire',
        }"
      >
        <vue-html2pdf
          :show-layout="true"
          :float-layout="false"
          :enable-download="false"
          :preview-modal="false"
          :paginate-elements-by-height="1400"
          filename="Passoni-bike-configuration"
          :pdf-quality="2"
          :manual-pagination="true"
          pdf-format="a4"
          pdf-orientation="portrait"
          pdf-content-width="100%"
          ref="html2Pdf"
          :html-to-pdf-options="htmlToPdfOptions"
          @beforeDownload="beforeDownloadPDF($event)"
          @hasDownloaded="pdfHasGenerated($event)"
          @progress="onPdfProgress($event)"
        >
          <div class="printable" slot="pdf-content">
            <div class="pdf-item" style="display: none">
              <canvas id="temp-canvas" width="1840" height="1200"></canvas>
            </div>

            <!-- <div style="width: 100%; height: 1100px; background-color: #000000;">only pdf</div> -->
            <div class="errors-wrapper" :class="{ visible: showError }">
              <div class="error">
                <span class="message"></span>
                <div class="close-button" v-on:click="showError = false">X</div>
              </div>
            </div>
            <keep-alive>
              <component
                ref="currentComponent"
                v-bind:is="contentByPhase"
                v-on:go-next="goNext"
                v-on:go-back="goBack"
                v-on:set-error="setError"
                v-on:set-intro-background="setIntroBackground"
                v-on:set-answer="setAnswer"
                v-on:skip-questionnaire="skipQuestionnaire"
                v-on:view-all-models="skipQuestionnaire"
                v-on:select-bike="selectBike"
                v-on:configure-bike="configureBike"
                v-on:set-measure="setMeasure"
                v-on:set-primary-color="setPrimaryColor"
                v-on:set-secondary-color="setSecondaryColor"
                v-on:set-frame-finish="setFrameFinish"
                v-on:set-stem="setStem"
                v-on:set-handlebars="setHandlebars"
                v-on:set-bartape="setBartape"
                v-on:set-groupset="setGroupset"
                v-on:set-crankset="setCrankset"
                v-on:set-bottlecages="setBottlecages"
                v-on:set-seatpost="setSeatpost"
                v-on:set-seatclamp="setSeatclamp"
                v-on:set-saddle="setSaddle"
                v-on:set-wheels="setWheels"
                v-on:set-tyres="setTyres"
                v-on:set-fork="setFork"
                v-on:set-colour-type="setColourType"
                v-on:update-title-font="setTitleFont"
                v-on:update-title-text="setTitleText"
                v-on:save-configuration="saveConfiguration"
                v-on:download-configuration="downloadConfiguration"
                v-on:ask-information="askInformation"
                v-on:confirm-configuration="confirmConfiguration"
                v-on:back-to-configurator="backToConfigurator"
                v-on:configure-another-bike="configureAnotherBike"
                v-on:back-to-summary="backToSummary"
                v-on:component-color-selected="setComponentColor"
                v-on:edit-single-component="editComponent"
                v-on:increment-base-step="incrementBaseStep"
                v-on:decrement-base-step="decrementBaseStep"
                v-on:set-base-step="setBaseStep"
                v-on:save-configuration-as-default="saveConfigurationAsDefault"
                v-on:goto-preconfigured="goToPreconfigured"
                v-on:generate-bike-image="generateBikePng"
                :questionAnswers="questionAnswers"
                :bikes="bikes"
                :bike="currentBike"
                :configuratorSteps="phases.configuration"
                :currentStep="phases[currentPhase][currentSubPhase]"
                :currentBaseStep="currentBaseStep"
                :results="results"
                :components="components"
                :measures="measures"
                :phases="phases"
                :steps="configurationSteps"
                :price="getPrice"
                :colors="colors"
                :bikeImage="bikeImage"
                :componentsConfig="componentsConfig"
                :bikeConfiguration="bikeConfiguration"
                :relatedCrankset="relatedCrankset"
                :loadedFromDb="loadedFromDb"
                :loggedUser="loggedUser"
                :defaultConfigurations="defaultConfigurations"
                :electronicMode="electronicMode"
                :isAdmin="is_admin"
                :reRenderImager="reRenderImager"
              ></component>
            </keep-alive>
          </div>
        </vue-html2pdf>
      </div>
    </section>
  </div>
</template>

<script>
/* eslint-disable no-debugger */
import Vue from "vue";
import axios from "axios";

const api = axios.create({
  auth: {
    username: "pixell",
    password: "pixelldemo",
  },
});

/* Bike PNG */

import { Canvg, presets } from "canvg";

const preset = presets.offscreen();

async function toPng(data) {
  const { width, height, svg } = data;
  /*
  const canvas = new OffscreenCanvas(width, height);
  */
  const canvas = document.getElementById("temp-canvas");
  const ctx = canvas.getContext("2d");
  ctx.imageSmoothingQuality = "high";

  const v = await Canvg.from(ctx, svg);

  // Render only first frame, ignoring animations and mouse.
  await v.render();

  /*
  const blob = await canvas.convertToBlob();
  const pngUrl = URL.createObjectURL(blob);
  */

  // return pngUrl;

  /*
  const tblob = require('blueimp-canvas-to-blob');
  canvas.toBlob(function (blob) {
  }, 'image/png')
  */
  return canvas.toDataURL();
}

function blobToDataURL(blob, callback) {
  var a = new FileReader();
  a.onload = function (e) {
    callback(e.target.result);
  };
  a.readAsDataURL(blob);
}

function toDataURL(url, callback) {
  var xhr = new XMLHttpRequest();
  xhr.onload = function () {
    var reader = new FileReader();
    reader.onloadend = function () {
      callback(reader.result);
    };
    reader.readAsDataURL(xhr.response);
  };
  xhr.open("GET", url);
  xhr.responseType = "blob";
  xhr.send();
}

/* End Bike PNG */

import { BootstrapVue, IconsPlugin, ModalPlugin } from "bootstrap-vue";

import "bootstrap-vue/dist/bootstrap-vue.css";

import ConfigurationModal from "./shared/configurationModal.vue";
import SaveModal from "./shared/saveModal.vue";
import LoginModal from "./shared/loginModal.vue";
import BuyModal from "./shared/buyModal.vue";

import VueHtml2pdf from "vue-html2pdf";

import IntroWelcome from "./phases/intro/welcome.vue";
import IntroQuote from "./phases/intro/quote.vue";
import IntroJourney from "./phases/intro/journey.vue";
import IntroCollection from "./phases/intro/collection.vue";

import QuestionnaireStart from "./phases/questionaire/start.vue";
import QuestionnaireQuestion1 from "./phases/questionaire/question-1.vue";
import QuestionnaireQuestion2 from "./phases/questionaire/question-2.vue";
import QuestionnaireQuestion3 from "./phases/questionaire/question-3.vue";
import QuestionnaireQuestion4 from "./phases/questionaire/question-4.vue";
import QuestionnaireQuestion5 from "./phases/questionaire/question-5.vue";
import QuestionnaireQuestion6 from "./phases/questionaire/question-6.vue";
import QuestionnaireResults from "./phases/questionaire/results.vue";

import SelectionList from "./phases/selection/list.vue";
import SelectionChooseBike from "./phases/selection/choose-bike.vue";

import ConfigurationBase from "./phases/configuration/base.vue";

import SummaryResults from "./phases/summary/results.vue";

Vue.use(ModalPlugin);
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);

Vue.component("configuration-modal", ConfigurationModal);
Vue.component("save-modal", SaveModal);
Vue.component("login-modal", LoginModal);
Vue.component("buy-modal", BuyModal);

Vue.component("intro-welcome", IntroWelcome);
Vue.component("intro-quote", IntroQuote);
Vue.component("intro-journey", IntroJourney);
Vue.component("intro-collection", IntroCollection);

Vue.component("questionaire-start", QuestionnaireStart);
Vue.component("questionaire-question-1", QuestionnaireQuestion1);
Vue.component("questionaire-question-2", QuestionnaireQuestion2);
Vue.component("questionaire-question-3", QuestionnaireQuestion3);
Vue.component("questionaire-question-4", QuestionnaireQuestion4);
Vue.component("questionaire-question-5", QuestionnaireQuestion5);
Vue.component("questionaire-question-6", QuestionnaireQuestion6);
Vue.component("questionaire-results", QuestionnaireResults);

Vue.component("selection-list", SelectionList);
Vue.component("selection-choose-bike", SelectionChooseBike);

Vue.component("configuration-base", ConfigurationBase);

Vue.component("summary-results", SummaryResults);

window.bikeConfigurationData = null;
window.mainSite = window.location.href.includes("pixelldemo")
  ? "https://passoni.pixelldemo.com/"
  : "https://passoni.com/";

export default {
  name: "MTMConfigurator",
  data() {
    return {
      phases: {
        intro: [
          "welcome",
          "quote",
          "journey",
          //"collection"
        ],
        questionaire: [
          "start",
          "question-1",
          "question-2",
          "question-3",
          "question-4",
          "question-5",
          "question-6",
          "results",
        ],
        selection: ["list", "choose-bike"],
        configuration: ["base"],
        summary: ["results"],
      },
      phaseOrder: ["intro", "questionaire", "selection", "configuration", "summary"],
      configurationSteps: [
        "frame",
        "colour",
        "fork",
        "stem",
        "bars",
        "groupset",
        "cages-bottles",
        "seat-post",
        "seat-clamp",
        "saddle-and-tape",
        "wheels",
        "tyres",
        //"cabling",
        //"accessories",
      ],
      currentPhase: "intro",
      currentSubPhase: 0,
      currentBaseStep: 0,
      componentsList: [],
      activeAccordion: "",
      bikes: [],
      currentBike: null,
      components: {},
      componentsConfig: {},
      bikeConfiguration: {},
      defaultConfigurations: [],
      price: 0,
      loggedUser: null,
      loginEmail: "",
      loginPassword: "",
      loginRes: "",
      loggedUserConfigurations: [],
      colors: [],
      showError: false,
      showMenu: false,
      showLoader: true,
      relatedCrankset: null,
      loadedFromDb: false,
      bagistoProductId: 78,
      csrf: null,
      electronicMode: false,
      singleColorMode: false,
      configPDF: null,
      bikeImage: null,
      isPDFDownload: false,
      selectedDealer: 84,
      confirmDisabled: true,
      is_admin: null,
      reRenderImager: true,
      currentConfigId: null,
      regeneratingBikeImg: false,
      // dev vars
      showDebug: false,

      // return vars
      questionAnswers: {},
      measures: {
        stem: null,
        handlebars: null,
        groupset: null,
      },
      results: {
        frame: {},
        stem: {},
      },
    };
  },
  components: {
    VueHtml2pdf,
  },
  mounted() {
    document.querySelectorAll("svg image").forEach((svgImage) => {
      if (svgImage.dataset && svgImage.dataset.href)
        this.componentsList.push({
          name: svgImage.id,
          nicename: svgImage.dataset.name,
          href: svgImage.dataset.href,
          category: svgImage.dataset.category,
          folder: "general",
        });
    });

    // load loggedUser from local storage
    if (localStorage.loggedUser) {
      if (localStorage.loggedUser == "null") {
        this.loggedUser = null;
      } else {
        try {
          this.loggedUser = JSON.parse(localStorage.loggedUser);
        } catch (error) {
          this.loggedUser = null;
        }
      }
    }

    // set default results
    this.results = this.getDefaultResults();

    let t = this;
    setTimeout(function () {
      t.showLoader = false;
    }, 3000);

    if (document.querySelector('meta[name="csrf-token"]')) {
      this.csrf = document
        .querySelector('meta[name="csrf-token"]')
        .getAttribute("content");
    }

    let uri = window.location.search.substring(1);
    let params = new URLSearchParams(uri);
    if (params.get("init") != null) {
      window.localStorage.removeItem("currentBike");
      window.localStorage.removeItem("currentPhase");
      window.localStorage.removeItem("currentSubPhase");
      window.localStorage.removeItem("preconfiguration-id");
      window.localStorage.removeItem("currentBikeConfig");
      window.localStorage.removeItem("preconfiguration-stored");
      window.history.pushState(null, null, window.location.pathname);
    }

    // riporta l'utente all'ultimo step (se diponibile)
    let currPhase = window.localStorage.getItem("currentPhase");
    let currSubPhase = window.localStorage.getItem("currentSubPhase");

    if (currPhase !== null) {
      this.removeIntroBackground();
      this.currentPhase = currPhase;
      this.currentSubPhase = parseInt(currSubPhase);

      let bike = window.localStorage.getItem("currentBike");
      this.currentBike = JSON.parse(bike);
    }
  },
  async created() {
    /*
     * Get CSRF Token
     */
    const requestToken = await api.get(`/api/mtm-configurator/csrf-token`);
    if (requestToken.data) {
      this.csrf = requestToken.data.token;
      this.is_admin = requestToken.data.is_admin;
      api.defaults.headers.common["Authorization"] = requestToken.data.token;
      api.defaults.headers.common["X-CSRF-TOKEN"] = requestToken.data.token;
    } else {
      this.setError("Unable to load. Reload page");
    }

    await this.loadBikes();

    /*
     *    Parsing GET params
     */
    let uri = window.location.search.substring(1);
    let params = new URLSearchParams(uri);
    let preconfigurationId = window.localStorage.getItem("preconfiguration-stored");

    if (preconfigurationId != null || params.get("load") != null) {
      if (params.get("load") != null) {
        this.currentConfigId = params.get("load");
        this.loadConfiguration(params.get("load"));
      } else if (preconfigurationId != null) {
        this.currentConfigId = preconfigurationId;
        this.loadConfiguration(preconfigurationId);
      }
      this.removeIntroBackground();

      // salva la configurazione di default (solo al primo caricamento della pagina)
      // in localstorage verrà salvato anche il riferimento della nuova
      // pre configurazione, in modo da poter utilizzare ask for information
      // e sapere quale lead ha generato la pre-configurazione
      const alreadyStored = window.localStorage.getItem("preconfiguration-stored");
      if (alreadyStored == null || alreadyStored != params.get("load")) {
        const self = this;
        setTimeout(function () {
          self.saveConfigurationAjax("#");
        }, 2000);
      }
    }
  },
  computed: {
    loginEmailState() {
      return (
        this.loginEmail.length >= 4 &&
        this.loginEmail.includes("@") &&
        this.loginEmail.includes(".")
      );
    },
    loginPasswordState() {
      return this.loginPassword.length >= 4;
    },
    contentByPhase: function () {
      return (
        this.currentPhase + "-" + this.phases[this.currentPhase][this.currentSubPhase]
      );
    },
    getPrice: function () {
      let baseprice = this.price;

      for (const [key, obj] of Object.entries(this.results)) {
        if (key != "frame" && key != "colour" && obj != null && obj.price != null) {
          baseprice = baseprice + obj.price;
        } else if (key == "frame" && obj.finish != null && obj.finish.price != null) {
          baseprice = baseprice + obj.finish.price;
        } else if (key == "colour" && obj.type != null && obj.type.price != null) {
          baseprice = baseprice + obj.type.price;
        }
      }

      return baseprice;
    },
    htmlToPdfOptions() {
      let options = {
        html2canvas: {
          scale: 2,
          letterRendering: true,
          image: { type: "jpg", quality: 2 },
          // Other options here
          onclone: (element) => {
            const svgElements = Array.from(element.querySelectorAll("svg"));
            svgElements.forEach((s) => {
              /*
              const bBox = s.getBBox();
              s.setAttribute("x", bBox.x);
              s.setAttribute("y", bBox.y);
              s.setAttribute("width", bBox.width);
              s.setAttribute("height", bBox.height);
              */
            });
          },
        },
        image: {
          type: "jpeg",
          quality: 2,
        },
        jsPDF: {
          unit: "mm",
          format: "a4",
          orientation: "portrait",
        },
      };

      // safari fix
      var userAgent = navigator.userAgent.toLowerCase();
      const isSafari = /safari/.test(userAgent) && !/chrome/.test(userAgent);

      if (isSafari) {
        options.html2canvas.allowTaint = true;
        options.html2canvas.useCORS = true;
        options.html2canvas.windowWidth = 4097;
      }

      return options;
    },
  },
  watch: {
    currentBike: function (val) {
      if (val != null) {
        let parent = this;
        this.price = val.price;

        axios
          .get("/api/mtm-configurator/bike/" + val.id + "/components")
          .then(function (res) {
            parent.components = res.data;

            // remove configurations steps not included in response
            const notExclude = ["accessories", "base"];
            let translations = {
              frame: "frame",
              color: "colour",
              fork: "fork",
              stem: "stem",
              handlebars: "bars",
              groupset: "groupset",
              bottlecages: "cages-bottles",
              seatpost: "seat-post",
              seatclamp: "seat-clamp",
              saddle: "saddle-and-tape",
              wheels: "wheels",
              tyres: "tyres",
              cabling: "cabling",
              crank: "crankset",
              accessories: "accessories",
              integratedhandlebar: "bars",
            };
            let keys = Object.keys(res.data);
            let newKeys = keys.map(function (e) {
              return translations[e];
            });
            let exludedElements = [];

            for (let j in parent.configurationSteps) {
              let key = parent.configurationSteps[j];
              if (!newKeys.includes(key) && !notExclude.includes(key)) {
                if (typeof key != "undefined") {
                  exludedElements.push(key);
                }
              }
            }

            const newConfiguration = parent.configurationSteps.filter((e) => {
              if (!exludedElements.includes(e) && typeof e != "undefined") {
                return e;
              }
            });

            parent.configurationSteps = newConfiguration;
          });

        // Get colors
        api.get(`/api/mtm-configurator/colors/${val.id}`).then((res) => {
          this.colors = res.data;
        });

        axios
          .get("/api/mtm-configurator/bike/" + val.id + "/componentsConfig")
          .then(function (res) {
            parent.componentsConfig = res.data;
          });

        axios
          .get("/api/mtm-configurator/bike/" + val.id + "/bikeConfig")
          .then(function (res) {
            parent.bikeConfiguration = res.data;
            window.bikeConfigurationData = JSON.parse(
              JSON.stringify(parent.bikeConfiguration)
            );
          });

        axios
          .get("/api/mtm-configurator/bike/" + val.id + "/defaultConfiguration")
          .then(function (res) {
            let resD = res.data;
            for (const [keyf, keyOj] of Object.entries(resD)) {
              if (resD[keyf] !== null) {
                resD[keyf].slotName = "noname";

                let dataIn = keyOj.data;
                try {
                  dataIn = JSON.parse(dataIn);
                  if (dataIn.slotName) resD[keyf].slotName = dataIn.slotName;
                } catch (err) {
                  console.log(err);
                }
              }
            }
            parent.defaultConfigurations = resD;
          });
      }
    },
    loggedUser: function (newLoggedUser) {
      localStorage.loggedUser = JSON.stringify(newLoggedUser);
      this.loadConfigurations(newLoggedUser.id);
    },
    currentBaseStep: function (newVal) {
      setTimeout(() => {
        /*
        if (this.electronicMode) {
          document
            .querySelectorAll("[data-is-electronic]")
            .forEach((element) => {
              if (
                element.dataset.isElectronic == 0 &&
                element.getAttribute("name") != "fork" &&
                (element.getAttribute("name") == "groupset" || element.getAttribute("name") == "handlebars" )
              ) {
                //|| element.getAttribute("name") == "crankset"
                element.setAttribute("disabled", "disabled");
                //element.parentNode.style.textDecoration = "line-through";
                element.parentNode.parentNode.parentNode.classList.add("line-through");
                //console.log(["[data-is-electronic]",element.getAttribute("name"),element.parentNode.style.textDecoration]);
              }
            });
        } else {
          document
            .querySelectorAll("[data-is-electronic]")
            .forEach((element) => {
              element.removeAttribute("disabled");
              //element.parentNode.style.textDecoration = "none";
              element.parentNode.parentNode.parentNode.classList.remove("line-through");
            });
        }
        */
      }, 300);
    },
  },
  methods: {
    loadBikes: async function () {
      const request = await api.get(`/api/mtm-configurator/bikes`);

      if (request.data) {
        this.bikes = request.data;

        let uri = window.location.search.substring(1);
        let params = new URLSearchParams(uri);
        let customerInfo =
          window.localStorage.getItem("customerName") != null &&
          window.localStorage.getItem("customerSurname") != null &&
          window.localStorage.getItem("customerEmail") != null;

        if (
          (this.$refs.currentComponent.resetFilters &&
            typeof this.$refs.currentComponent.resetFilters === "function") ||
          (params.get("bike") != null && customerInfo != false)
        ) {
          if (params.get("bike") != null) {
            window.localStorage.removeItem("currentBike");
            window.localStorage.removeItem("currentPhase");
            window.localStorage.removeItem("currentSubPhase");
            window.localStorage.removeItem("preconfiguration-id");
            window.localStorage.removeItem("currentBikeConfig");
            window.localStorage.removeItem("preconfiguration-stored");

            let bikeId = params.get("bike");
            let bike = this.bikes.find((b) => b.id == bikeId);

            if (bike) {
              this.currentBike = bike;
              this.currentPhase = "selection";
              this.currentSubPhase = 1;

              window.localStorage.setItem("currentPhase", this.currentPhase);
              window.localStorage.setItem("currentSubPhase", this.currentSubPhase);
              window.localStorage.setItem("currentBike", JSON.stringify(bike));
            }
          } else {
            this.$refs.currentComponent.resetFilters();
          }
        }
      } else {
        this.setError("Unable to load bikes. Reload page");
      }
    },
    saveBikeConfig: function (confName, confVal, type = null, id = null) {
      let currConfig = window.localStorage.getItem("currentBikeConfig");
      currConfig = currConfig == null ? {} : JSON.parse(currConfig);
      currConfig[confName] = {
        value: confVal,
        type,
        id,
      };
      currConfig = JSON.stringify(currConfig);
      window.localStorage.setItem("currentBikeConfig", currConfig);
    },
    loadBikeConfig: function () {
      let currConfig = window.localStorage.getItem("currentBikeConfig");

      if (currConfig !== null) {
        currConfig = JSON.parse(currConfig);
        console.log(currConfig);

        // visualizza la configurazione sulla pagina di summary
        this.currentPhase = "summary";
        this.currentSubPhase = 0;

        const isEmpty = Object.keys(currConfig).length === 0;
        if (isEmpty) return;

        if (currConfig.measure?.value) {
          this.setMeasure(currConfig.measure.type, currConfig.measure.value);
        }

        if (currConfig.primaryColor?.value) {
          this.setPrimaryColor(currConfig.primaryColor.value);
        }

        if (currConfig.secondaryColor?.value) {
          this.setSecondaryColor(currConfig.secondaryColor.value);
        }

        if (currConfig.fork?.value) {
          this.setFork(currConfig.fork.value);
        }

        if (currConfig.frameColor?.value) {
          this.setFrameColor(currConfig.frameColor.value, currConfig.frameColor.type);
        }

        if (currConfig.colorType?.value) {
          this.setColourType(currConfig.colorType.value);
        }

        if (currConfig.titleFont?.value) {
          this.setTitleFont(currConfig.titleFont.value);
          this.$emit("update-title-font", currConfig.titleFont.value);
        }

        if (currConfig.titleText?.value) {
          this.setTitleText(currConfig.titleText.value);
        }

        if (currConfig.frameFinish?.value) {
          this.setFrameFinish(currConfig.frameFinish.value);
        }

        if (currConfig.stem?.value) {
          this.setStem(currConfig.stem.value);
        }

        if (currConfig.handlebars?.value) {
          this.setHandlebars(currConfig.handlebars.value);
        }

        if (currConfig.bartape?.value) {
          this.setBartape(currConfig.bartape.value);
        }

        if (currConfig.groupset?.value) {
          this.setGroupset(currConfig.groupset.value);
        }

        if (currConfig.crankset?.value) {
          this.setCrankset(currConfig.crankset.value);
        }

        if (currConfig.bottlecages?.value) {
          this.setBottlecages(currConfig.bottlecages.value);
        }

        if (currConfig.seatpost?.value) {
          this.setSeatpost(currConfig.seatpost.value);
        }

        if (currConfig.seatclamp?.value) {
          this.setSeatclamp(currConfig.seatclamp.value);
        }

        if (currConfig.saddle?.value) {
          this.setSaddle(currConfig.saddle.value);
        }

        if (currConfig.wheels?.value) {
          this.setWheels(currConfig.wheels.value);
        }

        if (currConfig.tyres?.value) {
          this.setTyres(currConfig.tyres.value);
        }
      }
    },
    cleanCategoryImages: function (category) {
      if (category != null && category.children.length) {
        let children = category.children;
        for (let i = 0; i < children.length; i++) {
          let e = children[i];
          e.removeAttribute("href");
        }
      }
    },
    toggleComponent: function (component) {
      this.calcPrice();

      if (component == null) return;

      if (component.id == -1) {
        const cat_id = component.bike_component_type_id;
        const category = document.querySelector('[data-idcat="' + cat_id + '"]');
        this.cleanCategoryImages(category);
      } else {
        let newid = "cmp_" + component.id;
        let imageComponent = document.querySelector(`image#${newid}`);
        console.log(newid);

        if (typeof imageComponent != "undefined" && imageComponent != null) {
          let sibilings = imageComponent.parentElement.children;

          for (let i = 0; i < sibilings.length; i++) {
            let e = sibilings[i];
            e.removeAttribute("href");
          }

          // rimuove le immagini fork deda se è stato selezionato il componente columbus
          if (component.name.toLowerCase().includes("columbus")) {
            const images = document.querySelectorAll('g[data-idcat="23"] image');
            images.forEach((image) => {
              image.removeAttribute("href");
            });
          }

          imageComponent.setAttribute("href", imageComponent.dataset.href);

          let currConfig = window.localStorage.getItem("currentBikeConfig");
          currConfig = JSON.parse(currConfig);
          let storedComponent = null;

          for (const key in currConfig) {
            const currComponent = currConfig[key];
            if (currComponent.value && currComponent.value.id === component.id) {
              storedComponent = currComponent.value;
            }
          }

          if (storedComponent && storedComponent.colour != null) {
            this.setComponentColor(
              storedComponent.colour,
              storedComponent.id,
              storedComponent.bike_component_type_id
            );
          }

          if (component.colour != null) {
            this.setComponentColor(
              component.colour,
              component.id,
              component.bike_component_type_id
            );
          }
        } else {
          console.log("no image found for " + component.name, newid, imageComponent);
          const cat_id = component.bike_component_type_id;
          const category = document.querySelector('[data-idcat="' + cat_id + '"]');

          if (category != null && category.children.length) {
            let children = category.children;
            for (let i = 0; i < children.length; i++) {
              let e = children[i];
              e.removeAttribute("href");
            }
          }
        }
      }

      // Qui rigenera canvas
      let t = this;
      setTimeout(function () {
        t.generateBikePng();
      }, 400);
    },
    toDataURL: function (src, callback) {
      var image = new Image();
      image.crossOrigin = "Anonymous";
      console.log("creating canvas ...");
      image.onload = function () {
        var canvas = document.createElement("canvas");
        var context = canvas.getContext("2d");
        /* canvas.height = this.naturalHeight;
        canvas.width = this.naturalWidth;
        context.drawImage(this, 0, 0);
        */
        var dataURL = canvas.toDataURL("image/jpeg");
        callback(dataURL);
      };
      image.src = src;
    },
    generateBikePng: function () {
      Canvg;

      var img = new Image(),
        svg = new XMLSerializer().serializeToString(
          document.querySelector("#cmp_imager svg")
        );
      // svg = svg.replace(/href="/g, 'href="https://www.passoni.com');

      svg = new DOMParser().parseFromString(svg, "text/html");

      var elNotVisible = svg.querySelectorAll("svg image:not([href])");

      Array.prototype.forEach.call(elNotVisible, function (node) {
        node.parentNode.removeChild(node);
      });

      svg = svg.getElementById("svg-image");
      svg.style.width = "2000px";
      svg.style.height = "1200px";

      svg = new XMLSerializer().serializeToString(svg);

      toPng({
        width: 1000 * 2,
        height: 600 * 2,
        svg: svg,
      }).then((pngUrl) => {
        /*
        const img = document.querySelector("#temp-canvas img");
        img.src = pngUrl;
        */
        this.bikeImage = pngUrl;

        // rigenera l'immagine
        let regeneratedImage = window.localStorage.getItem("regenerated-image");

        if (this.currentConfigId != null && !this.regeneratingBikeImg) {
          this.regeneratingBikeImg = true;

          const formData = new FormData();
          formData.append("configId", this.currentConfigId);
          formData.append("image", pngUrl);

          api
            .post("/api/mtm-configurator/regenerate-bike-image", formData, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            })
            .then((res) => {
              this.regeneratingBikeImg = false;
            });
        }
      });
    },
    calcPrice: function () {
      return this.price + Math.random() * 100;
    },
    getComponentsByCategory: function () {
      let list = {};

      for (let len = 0; len < this.componentsList.length; len++) {
        if (!list[this.componentsList[len].category]) {
          list[this.componentsList[len].category] = [];
        }
        list[this.componentsList[len].category].push(this.componentsList[len]);
      }
      return list;
    },
    isActiveAccordion: function (key) {
      return this.activeAccordion == key;
    },
    setActiveAccordion: function (key) {
      this.activeAccordion = key;
    },
    goNext: function () {
      if (this.currentPhase == "configuration") {
        // salva la configurazione corrente
        // this.removeLoadParam();
        // this.saveConfigurationAjax("#");

        const self = this;
        setTimeout(function () {
          self.loadBikeConfig();
        }, 600);

        window.removeEventListener("beforeunload", this.showAlert);
      }

      if (this.currentPhase == "end") {
        return;
      }

      let nextSubPhase = this.currentSubPhase + 1;
      if (nextSubPhase >= this.phases[this.currentPhase].length) {
        this.currentSubPhase = 0;

        let nextPhaseIndex = this.phaseOrder.indexOf(this.currentPhase) + 1;
        if (nextPhaseIndex < this.phaseOrder.length) {
          let nextPhase = this.phaseOrder[nextPhaseIndex];
          this.currentPhase = nextPhase;
        } else {
          this.currentPhase = "end";
        }
      } else {
        this.currentSubPhase = this.currentSubPhase + 1;
      }
      if (!(this.currentPhase == "intro" && this.currentSubPhase == 0)) {
        this.removeIntroBackground();
      }

      window.localStorage.setItem("currentPhase", this.currentPhase);
      window.localStorage.setItem("currentSubPhase", this.currentSubPhase);
    },
    goBack: function () {
      if (this.currentPhase == "end") {
        return;
      }
      let nextSubPhase = this.currentSubPhase - 1;
      if (nextSubPhase < 0) {
        let nextPhaseIndex = this.phaseOrder.indexOf(this.currentPhase) - 1;
        if (nextPhaseIndex >= 0) {
          let nextPhase = this.phaseOrder[nextPhaseIndex];
          this.currentPhase = nextPhase;
          this.currentSubPhase = this.phases[this.currentPhase].length - 1;

          // previene di visualizzare la pagina risultati
          if (this.currentPhase == "questionaire") {
            this.currentSubPhase = 0;
          }
        }
      } else {
        this.currentSubPhase = nextSubPhase;
      }

      window.localStorage.setItem("currentPhase", this.currentPhase);
      window.localStorage.setItem("currentSubPhase", this.currentSubPhase);
    },
    setError: function (str) {
      this.showError = true;
      let parent = this;
      let componentImage = null;
      if (document.getElementsByClassName("errors-wrapper").length) {
        document.querySelector(".errors-wrapper .error .message").innerHTML = str;
        setTimeout(function () {
          parent.showError = false;
        }, 2500);
      }
    },
    skipQuestionnaire: function () {
      // l'utente deve essere obbligato ad inserire le proprie generalità
      // in modo tale da poter essere ricontattato
      let firstName = window.localStorage.getItem("customerName");
      let surname = window.localStorage.getItem("customerSurname");
      let email = window.localStorage.getItem("customerEmail");

      if (
        firstName == null ||
        firstName == "" ||
        surname == null ||
        surname == "" ||
        email == null ||
        email == ""
      ) {
        this.currentPhase = "questionaire";
        this.currentSubPhase = 2;
      } else {
        this.currentPhase = "selection";
        this.currentSubPhase = 0;
      }

      window.localStorage.setItem("currentPhase", this.currentPhase);
      window.localStorage.setItem("currentSubPhase", this.currentSubPhase);
      window.scrollTo(0, 0);
    },
    setAnswer: function (val, index) {
      this.questionAnswers[index] = val;
      window.localStorage.setItem(
        "questionAnswers",
        JSON.stringify(this.questionAnswers)
      );
    },
    setIntroBackground: function () {
      document.body.classList.add("intro-background");
    },
    removeIntroBackground: function () {
      document.body.classList.remove("intro-background");
    },
    selectBike: function (bike) {
      this.currentBike = bike;
      this.currentPhase = "selection";
      this.currentSubPhase = 1;

      window.localStorage.setItem("currentPhase", this.currentPhase);
      window.localStorage.setItem("currentSubPhase", this.currentSubPhase);
      window.localStorage.setItem("currentBike", JSON.stringify(bike));
    },
    configureBike: function () {
      // l'utente ha richiesto di configurare la bici da 0
      // vengono rimossi eventuali parametri sull'url
      this.removeLoadParam();
      this.clearLocalConfig();
      this.currentPhase = "configuration";
      this.currentSubPhase = 0;
    },
    removeLoadParam: function () {
      let url = new URL(window.location.href);
      url.searchParams.delete("load");
      window.history.replaceState({}, "", url);
    },
    clearLocalConfig: function () {
      window.localStorage.removeItem("currentBikeConfig");
      window.localStorage.removeItem("preconfiguration-id");
    },
    setMeasure: function (type, measure) {
      if (measure) {
        if (this.results[type]) {
          this.results[type].measure = measure;
        }

        if (type == "stem") {
          this.results.stem.measure = measure;
        }
        this.measures[type] = measure;
        this.saveBikeConfig("measure", measure, type);
      }
    },
    setPrimaryColor: function (e) {
      this.results.colour.primaryColor = e;
      this.setFrameColor(e, 0);
      this.saveBikeConfig("primaryColor", e);
    },
    setSecondaryColor: function (e) {
      this.results.colour.secondaryColor = e;
      this.setFrameColor(e, 1);
      this.saveBikeConfig("secondaryColor", e);
    },
    setFrameColor: function (color, type) {
      console.log("******** SET FRAME COLOR ********");
      console.log("Color Type", type);
      console.log("Color", color);
      const category = document.querySelectorAll('[color-type="' + type + '"]');
      const element = document.querySelector(
        '[color-type="' + type + '"][color="' + color + '"]'
      );

      console.log('[color-type="' + type + '"]');
      console.log('[color-type="' + type + '"][color="' + color + '"]');

      if (category != null) {
        for (let i = 0; i < category.length; i++) {
          let e = category[i];
          e.removeAttribute("href");
        }
      }

      if (element) {
        element.setAttribute("href", element.dataset.href);
      }

      if (type == 1) {
        this.saveBikeConfig("frameColor", color, type);
      }

      console.log("****************");
    },
    setComponentColor: function (color, componentId, componentType, store = true) {
      var colorName;
      if (typeof color == "string") {
        colorName = color;
      } else {
        colorName = color.name;
      }

      const cmpId = "cmp_" + componentId;
      const category = document.querySelectorAll(
        '[color-type="2"][id="' + cmpId + '"], [color-type="0"][id="' + cmpId + '"]'
      );
      const element = document.querySelector(
        '[color-type="2"][id="' +
          cmpId +
          '"][color="' +
          colorName +
          '"], [color-type="0"][id="' +
          cmpId +
          '"][color="' +
          colorName +
          '"]'
      );

      if (category != null) {
        for (let i = 0; i < category.length; i++) {
          let e = category[i];
          e.removeAttribute("href");
        }
      }

      if (element != null) {
        element.setAttribute("href", element.dataset.href);
      }
      console.log("SET COMPONENT COLOR", componentType, colorName);

      if (typeof color != "string" && this.results[componentType]) {
        this.results[componentType].colour = colorName;
      }

      if (store) {
        this.saveBikeConfig("componentColor", color, componentType, componentId);

        let component = this.results[componentType];
        if (component) {
          component.colour = color.name;
          this.saveBikeConfig(componentType, component);
        }
      }
    },
    setColourType: function (e) {
      this.results.colour.type = e;
      this.saveBikeConfig("colorType", e);
    },
    setTitleFont: function (e) {
      this.results.frame.title.family = e;
      this.saveBikeConfig("titleFont", e);
    },
    setTitleText: function (e) {
      this.results.frame.title.text = e;
      this.saveBikeConfig("titleText", e);
    },
    setFrameFinish: function (e) {
      this.results.frame.finish = e;
      this.saveBikeConfig("frameFinish", e);
    },
    setStem: function (e) {
      this.toggleComponent(e);
      this.results.stem = e;
      // this.resetComponentColor("stem", "stem");
      this.saveBikeConfig("stem", e);
    },
    setHandlebars: function (e) {
      this.toggleComponent(e);
      this.results.handlebars = e;
      // console.log("handlebars => ", e);
      // this.resetComponentColor(this.results.handlebars.bike_component_type_id, "handlebars");
      // this.resetComponentColor("handlebars", "handlebars");
      if (e.is_electronic) {
        delete this.results["stem"];
        var stem = document.querySelectorAll("#gcmp_9 image[href]");

        console.log();

        stem.forEach(function (e) {
          e.removeAttribute("href");
        });

        // è inutile mostrare il messaggio se l'utente seleziona il componente deda
        // il componente deda rimuove automaticamente l'attacco manubrio
        // quindi si mostrerebbe il messaggio di rimozione per qualcosa che non può selezionare
        if (!this.results.fork.name.toLowerCase().includes("deda")) {
          this.setError("Stem will be removed from your configuration");
        }
      }

      this.saveBikeConfig("handlebars", e);
    },
    setBartape: function (e) {
      this.toggleComponent(e);
      this.results.bartape = e;
      this.results.bartape.colour = null;
      this.saveBikeConfig("bartape", e);
    },
    setGroupset: function (e) {
      this.toggleComponent(e);
      this.results.groupset = e;
      if (e.related_id) {
        let related = this.getComponentById(e.related_id);
        this.setCrankset(related);
        this.relatedCrankset = related;
      }
      this.saveBikeConfig("groupset", e);
    },
    setCrankset: function (e) {
      this.toggleComponent(e);
      this.results.crankset = e;
      this.saveBikeConfig("crankset", e);
    },
    setBottlecages: function (e) {
      this.toggleComponent(e);
      this.results.cagebottle = e;
      // this.resetComponentColor("cagesbottle", "cagebottle");
      this.saveBikeConfig("bottlecages", e);
    },
    setSeatpost: function (e) {
      this.toggleComponent(e);
      this.results.seatpost = e;
      this.saveBikeConfig("seatpost", e);
    },
    setSeatclamp: function (e) {
      this.toggleComponent(e);
      this.results.seatclamp = e;
      this.saveBikeConfig("seatclamp", e);
    },
    setSaddle: function (e) {
      this.toggleComponent(e);
      this.results.saddle = e;
      this.saveBikeConfig("saddle", e);
    },
    setWheels: function (e) {
      this.toggleComponent(e);
      this.results.wheels = e;
      this.saveBikeConfig("wheels", e);
    },
    setTyres: function (e) {
      this.toggleComponent(e);
      this.results.tyres = e;
      this.saveBikeConfig("tyres", e);
    },
    setFork: function (e) {
      if (e.is_electronic) {
        this.activateElectronicMode(e);
      } else {
        this.deactivateElectronicMode(e);
      }

      this.toggleComponent(e);
      this.results.fork = e;
      // this.resetComponentColor("fork", "fork");
      let currentConfig = this.getCurrentConfig();

      // viene utilizzato il colore selezionato dall'utente
      if (currentConfig && currentConfig.primaryColor != null) {
        this.setComponentColor(
          currentConfig.primaryColor.value,
          e.id,
          e.bike_component_type_id
        );
      }

      if (this.results.stem != null) {
        this.$emit("set-error", "Handlebars will be removed");
      }

      this.saveBikeConfig("fork", e);
    },
    activateElectronicMode: function (p = null) {
      this.electronicMode = true;
      /*
      if(p==null || p!=null && p.id != 89){
        // removing stem

      }
      */
      if (this.currentPhase != "configuration") return;

      this.configurationSteps.splice(3, 1);

      // disable not electric items
      document.querySelectorAll("[data-is-electronic]").forEach((element) => {
        if (
          element.dataset.isElectronic == 0 &&
          element.getAttribute("name") != "fork" &&
          (element.getAttribute("name") == "handlebars" ||
            element.getAttribute("name") == "groupset" ||
            element.getAttribute("name") == "stem" ||
            element.getAttribute("name") == "crankset")
        ) {
          element.setAttribute("disabled", "disabled");
        }
      });
    },
    deactivateElectronicMode: function (p = null) {
      this.electronicMode = false;

      // adding stem
      if (!this.configurationSteps.includes("stem"))
        this.configurationSteps.splice(3, 0, "stem");

      // enable all items
      document.querySelectorAll("[data-is-electronic]").forEach((element) => {
        element.removeAttribute("disabled");
      });
    },
    resetComponentColor: function (colorComponentType, resultsComponentType) {
      const category = document.querySelectorAll(
        '[color-type="2"][id="' + colorComponentType + '"]'
      );

      if (category != null) {
        for (let i = 0; i < category.length; i++) {
          if (category.id != this.results[resultsComponentType].id) {
            category[i].removeAttribute("href");
          }
        }
      }

      if (
        typeof this.results[colorComponentType] != "undefined" &&
        this.results[colorComponentType] != null
      ) {
        this.results[colorComponentType].colour = null;
        this.components[colorComponentType].colour = null;
      }
    },
    setLoginEmail: function (e) {
      this.loginEmail = e;
    },
    setLoginPassword: function (e) {
      this.loginPassword = e;
    },
    setSelectedDealer: function (e) {
      this.selectedDealer = e;
    },
    encodeData: function (ret) {
      const json = JSON.stringify(ret);
      //const encoded = encodeURIComponent(btoa(json));
      return json;
    },
    saveConfiguration: function () {
      // this.$refs.html2Pdf.generatePdf();
      console.log("output pdf");
      this.$refs.html2Pdf.downloadPdf();
      this.$root.$emit("bv::show::modal", "save-configuration");
      console.log("Saving...");
    },
    blobToBase64: function (blob) {
      return new Promise((resolve, _) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.readAsDataURL(blob);
      });
    },
    saveConfigurationAjax: function (iSdefault = false) {
      this.showLoader = true;
      let slotSlice = iSdefault == false ? "0#noname" : iSdefault.split("#");
      let slotN = parseInt("" + slotSlice[0]);
      let slotName = slotSlice.length > 1 ? slotSlice[1] : "noname";
      const slot = iSdefault == false ? null : slotN;

      const ret = {
        currentBike: this.currentBike,
        price: this.getPrice,
        questionAnswers: this.questionAnswers,
        measures: this.measures,
        results: this.results,
        slotName: slotName,
      };

      const formData = new FormData();
      formData.append("data", JSON.stringify(ret));
      formData.append("user_email", this.loginEmail);
      formData.append("price", this.getPrice);
      formData.append("bike_id", this.currentBike.id);
      formData.append("dealer", this.selectedDealer);
      formData.append("image", this.bikeImage);

      if (iSdefault) {
        formData.append(
          "default",
          JSON.stringify({
            isDefault: iSdefault != false,
            slot: slot,
          })
        );

        api
          .post("/api/mtm-configurator/save-preconfiguration", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((res) => {
            let data = res.data;
            if (data.res) {
              this.showLoader = false;
              window.localStorage.setItem("preconfiguration-id", data.id);
              window.localStorage.setItem("preconfiguration-stored", data.id);
              // window.localStorage.setItem("currentBikeConfig", data.configuration);
            }
          })
          .catch(function (error) {
            console.log("error saving configuration");
          });
      } else {
        formData.append("file", this.configPDF);

        api
          .post("/api/mtm-configurator/save-configuration", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((res) => {
            let data = res.data;
            if (data.res) {
              this.showLoader = false;
              this.$root.$emit("bv::hide::modal", "save-configuration");
              window.location.href = "/thank-you";
            } else {
              console.error("Error saving configuration => ", data);
              this.setError("Cant load configuration");
            }
          });
      }
    },
    saveConfigurationAsDefault: function (i) {
      this.saveConfigurationAjax(i);
    },
    downloadConfiguration() {
      this.isPDFDownload = true;
      this.showLoader = true;
      this.$refs.html2Pdf.generatePdf();
    },
    askInformation() {
      // controlla che ci sia una pre-configurazione salvata
      // la pre-configurazione viene creata alla prima selezione del modello
      // in questo modo è possibile sapere quale lead ha generato la pre-configurazione
      const preConfigId = window.localStorage.getItem("preconfiguration-id");

      if (preConfigId != null) {
        const url = `/en/contact?config=${preConfigId}&type=mtm`;
        window.open(url, "_blank");
        return;
      }

      // se la preconfigurazione non è disponibile, viene caricato il riferimento
      // di una pre-configurazione generica appartenente allo stesso modello
      // ma non necessariamente creata dal lead corrente
      let uri = window.location.search.substring(1);
      let params = new URLSearchParams(uri);
      const config = params.get("load");

      if (config != null) {
        const url = `/en/contact?config=${config}`;
        window.open(url, "_blank");
        return;
      }
    },
    async beforeDownloadPDF({ html2pdf, options, pdfContent }) {
      options.pagebreak = {
        mode: "",
        before: ".before",
        after: ".after",
        avoid: ".avoid",
      };
      options.enableLinks = true;
      options.filename = this.currentBike.slug + ".pdf";

      var content = pdfContent.cloneNode(true);

      content.getElementsByClassName("printable")[0].innerHTML =
        `<div style="background-color: #000000; width: 800px; height: 1123px; color: #ffffff;"><div style="width: 100%; height: 100%; display: table;"><div style="display: table-cell; vertical-align: middle; text-align: center;"><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAUAAAAA1CAYAAAFHDwL6AAAABGdBTUEAALGPC/xhBQAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAABQKADAAQAAAABAAAANQAAAAC7+bnUAAAd3ElEQVR4Ae2dB7glRZXHkTQoIzAEyTAgqAgrQUWWqEQRE2BCCYrKmhA/RxZRcQFxQUQBXR0VI0pa1AVZBBScEZVgAkFJggQRWTIDCAxh9vfv1+dO3bpV1dXpvTd+c77vTFWd8D+n6tar7q6ue2eRRRI0b968KSE18lsj8l3QXRDSSYbu1zFdVI7TPFO6dcn8ttmFSteW+qKujauTnPaDKb3psJs6lIQPVII9ZQ5le5bbtnrIt7Rf3GysDNlGZFOHemoAJfDDZdu3uUtgItf+GdCYtPj3EEf3hFNPVc/2MQvjoNCBSeljOsmh1QVDOfQJlLKhzlk4OVm9tIuPoBnayFg7p5QPdsvKlupixL0w189PcmgOGghGK1hdpetE/b2mo/5Mpz7oPfI7Te6X6LbxZW4bvTpXEPWpVs8ucVodvjbkgPzekFwydDPh7WL6qBwnt+eDegnqt++LAmUqCHeSa0r7OV4Og3W0kHvKQULIX+zqQgl7gbZy21b3MUI4soFWLnXhBDHY20CtRPZB+HnWLgEQFXS+J59jCk8+6LTJZWd1K01GGU7QDFViVPwFlvURsFJ+A3bnqe6TBZPcrZtdSGa26KoTNCBzcttuHbDgtdVNwK27vqG6bEWmK+quwBR+aTZWSk/dvVoMjXrA/2mT4VfMNWv7pRdjXvERuEI50P6TLwsBYfM5X+63sRkZZWFDi/m21ka3g9WtlIPVY2XIBtka8PExH8nlJ4rZoBpMO7NBNrXw0T8iU1g5Jh2VS4/uMPgx2Zh9qKzSd+lDrG+E8EymXKBVre2X6OYWFuFbh24H0IKXAaODiP5vZkN5tPmlSsde1T1TttKZfZ92xIgO4OBWF6NNyyRu4v5oTnm/lMxLNtaBkD2y4oZQINjpnmtosCM+7q3MOjk+ySRrKpWTYopw3Y/myUmIMdPhjsUcsP2Kr0O2ZIlxrq9LtevENZzS57fWtlJyq8fKuvGw39J8KKMzsM6fwGcTyf1dwXx9SGY2MR3ymWbjlzEf2VXoTkd/nI+X0xauyLdFNHYR8RV9tAn2AlgPlOK1cmJgtxP8E/i7sP/Qm4TAfjl456RRDSVYr69hnmcK6B/zLIvZoRnwOPzBGj6/xP5B+NW5PrLDfmP4cvibdfwa2xJIdLsLMCaat5or8+uy8WV+G5PdA7J3Ih/aNHJt0F3vtlVHdiN8hi932+j3gZd0ZaojS+YpvZHvm2qbT+xPYzOcdQsyeGZywZAXA0D5HFceqO/ry7iq6X5tpKOO3eZOvajisx6VwdXZ15PHRciewG6ur0NWXFV9udP+mtXBOcjq2SVOoqEZKOcxcfzTy9CviU36FsDLEvuL4CU8cWVTuaSMUBdP6iEbdF+VXBiikE1INmZdc3EuAy0dAgzIlke2T0CeEslnZBalHDI7XVy4sJ2ewNpLuky8+TDlSA7NQGTPLOWhNezsMtBSpc135qMN10p9UQxr4i3H55G41XyN2c+XhGsxO+TFDJSX2VBeGkaZLzVbc/IHUPqvzzcP1wYgYXUhNRuvjK29yqd4YvHso39aZpdIYSgP3w7/wQBKVxfPOqKN3E3hTQSihRd6l+ouoT/KbVO/zWuPNMegim30zzvKp8AaLN6OXLGfcnxmmQ570YrW7rEsdtoVLCuGDEU5xpgVa4lrWzhn+ptfXR/snxXzicktlpWl3dPWthL50AyUHNl9pf1jZueXpb7eHT4zo3LG+YFCbc2wkDwmw/wf6AbvY2J2MTmdXUo6cOwvLmZayLHTxUw0Bd/grdyYepFFsgBlDJC9SzRfKz9U6rc0QR8lnRrZyFAc5Dkfxv11c3JwH0j62lRMGlUom2Dgo1k1RMi2GRI4DXSHwDMc0aCK/HD43QOBV0EXXaJQjfwJmzu642O+kouyrjrYDb3qtABWFkgCc4jm1pI7okE1If9yQnfDACBQwW8leA1fFcMzO/TRAZRNzF9ykeH0WhLnE/AlsH8Vj8bF9gT4MvjgqFFEgc928HoRdbdiArl0L429HH4HdW0piX4Er902OhgXCKwtjvkD9Vz4SZUmsxLZovA1sN53tBpQ/I+Fr4BHrhvI1odFV1jsLkrwzoCPDWEhV9++D18T0teRgeHTyEu9KjwALqiykR67Yh/VAg6WwFJwewoEmyfMkfJdKduQDp+tHP9WkxCcWhvC2GtFEL0slFtMhv2J8C9jel+OrSZ7477hemZdf+ynyQe62c8np43fVwvv4X9qnUPBtf8JqM4M5zivbpIHe/5X5wxQyKbE+XhI15WMGK9RnK7wUjiEOUCxRCm7lG7Mu/j3nJSdr8OjuA+h/JKDYdWszUWMJ2QCZg8WCRZHyyh3tp6V5V7+gFS18dNp2IKqbNvoCVC8aqQ8qw1OlS/4fyk6M/bPRlX2MT3uhzs4T8TsfDk+xQSUnLou7T7pFUKScJi8E5DkZrvZ077Q62HOs6wL4a/E2hpLnqgacs5sgPkeL89O7/GUBvg/cGNkphY1c7Go/zlq6CiwG0xAEyO7GR4i04VKDPufgAS50sko634D++3hkWXcwSmqoU5VyXB070l9SLVPhp9VhZPS47+GgBKkB6CDUhgpnY+bss3RNcHDZ2QCKhby5/l4tF8SygN5owk48kTngwM8HS4uEej+rh2yktbxbSPtjbAfuRwIw7Unxt/cdk4diCWEI8I+dJpG7wMfAdulk3KwzQbo24sAYzG0H+Xft+qIqD3guHHWN4wFtaTLN6jvXv6/oZN3eLLmTXfEVG+ONOrpY2e0DxxFaSch5tGRuIu3Q57vDb5e1rhXh0HI+Vbh2sCwrISt8qVN8PAJroBuVGxm+Ni0BwsY9UYroH8v1dkEJKHKl9LqIHbnwi6lzsu4Y1K7TpA73EC1ATId3BjUk0ea0e/v2meGiJq5WNQPixo6CuwqJ6CZe/hqFudFKSfPBCSZXS3hnFK9cCnHp6nNBMQJvkR08yenU5y8NnV1depgfMTBuTjXF5/sCShM7PWGxadJNQH3yO282Xm9mWPyWIn9i2K6lNyJs0HKrq3O4uTiYL92XR8f2/wpX+rrUm3sa01AYeGzghOvqKZimA7D5JuQ1pdgAvzegtUp8Xth0Yv5/xwR88dkx9LsUzGbkByfX8svpAvJML1N9tCzQ/qYbMwl/l3fmJ/k+NoluTiDkrI1HT72KvAAk9Up8a89AQ0f3+JrapRZ44pZfxMQ8JEvvliiOSX+p8EuLZPyw1Ab0tqK0SBsH7JFrq8h3wUfH9LnyPA9DhZdDNthoyFX5LbB3tm5IDDfBOt8+shZcWRvhP8BzxhKpEEDjMYTUOHw3wNuNgEb5NvKhTx/Dy/XCiTgDKZWjt/B2na5B9Z9VXDPKuCeJQJPp511xuh6WBNfK+Sn4KlZAA2NwP8ArEMhf4R19l73eiN7qw3hJ9aNjrjknoR5M4pPw9pofQhufKTR7SE4opGvXbs2depg/QL+ZsgHefEul/K7IX2uDP/FYa2yu4V8kH8bFtW+9w3hSQaWvpuqcX9eyAb51rAomFPIJyTD37/qjJzbDfn5MnCST/tmr4RdUkcHZEZ+icFGA6PITzf4PqE2GB8znJC+rgwsrULTqvyw0as6Ue03FvjoZvvxjBjrKUBJq1fZp/Rg3A1n/dFgp/1HjcOUFGZMh9+psE+nxuxjcgD6m4AKSoDNnSznxhJJyR1/VV+Xsq3S4a97o+wjYQooqsL19XV8sH2p7KHQWxkfeqSNn32hqe5pFo2FaMMR0AoBPpqA/jtvYdX6I8K+3wmofigrh+6u6NuQGj8bXIMYeT035JBoALCsQBImIyrMN4RfNaJICLD/Jlw3zuwEZFRFGF3mC4oaJRTmS/mChNmICvtitaP8PwejqI4YJwQ4jMsEPN1LcslETkMq/C6Eh15XDRnUaIBTnCCp4dLItOzrnxs513QqY6l4X03Xwhw/PaQY+e9vo5A4DC635uyU2Vtq+DSagIN3edEMhxX+7vqRw+pkS/dRQ1slJN3oUgVOZzf7yYzHlOtm2LQyYRwuMwDe/X/Z6jVL95Ym9hWyKsjNPAN923QrT9Zpc9GaaPd79jt47WCTTmyLYg8G9z7P4D1eu1YT3NfXcmhmXHeMakWhD7qKvKyWU8CYsX3UEetwRO3TOGBcAcZsB0fV7K8jeH5ZzbqD619yc78Qcy6dsyfJI93MGKg13XbN+v/g3+senPIhxoM186pjfqtj3HZ7yr1fvd7Bza7yOb3CN6b/d/myrtp1J6B/XPzYzET+w+zo4KBeymabrkZ5uWOrvbKTnHYf1WWIIXp5D+CrOJiXOPUmVfeeLfs+MBBoWU+2En0/wJN10yyGtfynChEzfdgDqrKXHuMjfDtk9w9AqPj6qjYu/hO1wengbGdvP8D6vAF7pR7Glq7Ks0oPxpYe7turfFJ6sL7k4e2bspcO+1NDNsiP8rDUXCxkW+I0eggZ2lqJgZcBBr/gWCam08GVhO3Idg2yzUoMK95ZCeQZ4LiPOUdK/cLG7p5b7SYYN0bwTTybytq1gXHA7ysGUpbbNMExHzA+7OGdbbpYiX1wAsoe3cMeXnTrDLveJ6Cby5RYh1w5Ds+GN3ZlVnfBVDd5nRK3VX2cSFtvCl5bB9u1xfeDEVxffAOCrD9M4WM7tC1F+/lu3Lp1/N8Fu+TeXwbhMI5OQDm4YGX9v0JA6BpNwMp7QIAPVWCC6u3HztzDieyBIpSLK/sxtn9wBU79v526Ohpd3l07tw528R0VZC+G/Sd011TH789WP6DaR/GJ8wVY91QzXNBAXU+eOgiR+wCwkoeR/iUazzjQ9H+WbZmATV2Rf7j4/fQv+4+sMpg+EYe2oq69H+P1KgESBuD8MKZGtyjs0pkx2zpyALeFk5fNOngxW2IcBGtljdEdMV+T46jTOy7VeothOFYCdIALRn2W6WIlNskVUH7Y6BTOEPl4KButgP4S29mWBgntNJRxRsPvVNs2IafDQw88ZRp/a4vt+oO5d4nrF/7q4bpp7I/xHFpt+oI1w8PL+Q8hKiegkvZw1Zztdob2pJuAlbvxJK3fDHNpE7dTXdUJsLEbRPWusF0cYL8lbIeedPV+HbsVHVtV3+Db1Gnj/xkPb+Uqf+xzJ+DqHraaLzJ86pNuAr7VkkuVXqfuSdm20RFnZS/W89vgxXyJ8XU3TszO5K4t9coVy/xCJf6XunghG1+GfdYElB+233bxVTc8qpNnApLMMZZYVYntvfCAquzb6Aly2SAQp4zbYKV8nRiDDyhmj62733ZJzC5HDtbTTuxfZPpkT0Dhgf+kE0PV4kmbclJNwNxXdOqQHnhcOiRn4JrYEMSNtUUTjBwf4vzBOpRpb+aVEzaFNwChkrJzdZjWnYCDY2NOvDdSnxwTkESmwe7rJbe/wbrTkaIaNOpACPjSFqsDuCgEMc6sEwfbwSoYBa1QgLGUxaSs3IA2OGxrTUD54aPv3/g0aSZg7Rfq9KQ43+f06Fk2QKESuyVD8ioZfvbNtaeqbKXHvtb3aw0TvztgUdaHUsayp/WDDadOSazzi4gZXx9wcfGpPQHLfO0Udhk2r69mbKUG2aXW2zCAneB2MKeOj7+sz0r5Ya+TyrUvofhcC4tGfkw6FE+GIXmVTH6iKjtfP+ZV3084TX3xazQB3Zhl7Kw/NsvTykHipaDVBATj1f6g5rYtIStTfjk2vj8+NslP8XWhNvb27vtPIX1Mhp+9tmt0zAx/3eS7p31ioQZy7LV6Zq3qA6eygl+bCfgv+BtNigk4x+9gbpte/Jv1pCx3jPmiL37hgDL7y1ElZvDrm6E42GuPzt50nBuy8WXYv6iMM9gf821y2mB8C05eBQwHu1vhodeapssp8W08AYWPv30VYFJMwMYrYNkZ+jMg94TvyFhipRXq3NJap0qC75KR692lvtO74ghIhgC/dWC93xW9I+SCfAl4NnxxSN9EBpZW7Fnw8b4/Mp141oPOLXCtnw0JYJ3my+q2yUHUaALqBfsCT3Re/dgT3gnWgYApsC6dv+EMQWeHVYmjl/DaYNcrM91HPgJfDf+QOJdQ9kbE1lsixbwPvpx4jS65fSRIbrp1W4ucsrffLA+tIjOtUbPUN+j1uu0u+Eb4Wlj/6/WkGRjy0SXiLRT2V/4+8mvaX8H1RuSpW45PwtvAV8IXwn+Bb4G12asrgv4ApsNbw6+B14Vvgb8Hz6Rvd1BOONGX1UniUHh/WHPkx7Am5y0l30mpU9fPgTeHd4C3h9XHc2D15eeUk5rop8b//fCb4Qdg3btr4dPn8BCsU2M6uKyr1DrwhvC2sP5gz4O/Cs+ir7UfWPHrjOiHPqeXJgCvJscvJ/SdqcjlQMBuI172VmIqOHhT0Mc3RjCI0e0pYFcHgF6zHgE/7oDp1zB0m/Ji13Y868TW+3P7VQ6qBWkSTgoimx1gvYnUNwk2bZIUfkvCx8JGem76GlzrXUCT2K4P8fQLJj+DFV8Hs5/h6nPr+O0I3w0b/YaKFscJJ/JYFtZY65Hi5/CqbZLCfwvYtlPPp75BG7ymvsQ9Fa4i/Q7Xck1j5PoR4wL46Fz7KjuwpsJR0h1SjLIXQDcJwNaE/x4AlUx3LuNGxLsukMedyBYftyQCgYj/EvgRWD+GsUbApJEIrPfAPp3YCCzTiWBagC8ugx6Q6VZpBp72Hux9UglfLIxLVjp3aEBgPSUdYwlQHtUhfAEF5rNh28xSqF/BK3UdJ4ZHrNPKmJqTVaQnqt6I4Av2AmgjQ0e+ERlJ3ZG90uz6KolxUiS+xJ3cXjfJndgfK/OaQ6nHo04JzCmwHcWZ3Sm4B0ac6fBcWLSPp+6kCe5HC/SxO/nndgKaAULM5eHLytgqdKfe6o6vKiz4uyqQQ5ojO1b5tdUTQ3eAehzXDdE5cBX9FINGd/hVuYL7z7EAloOpR7sYfaZqMJrqCbg37D5GhXKY0RS/qR9JvMNJ5ItNcXL8iLNbjl1TG/D1JubRsj/a5+uNiKGnilavNuskR6wvlv2y4qo6/m1sCbgGrJsEl/Qkoz3TXgjswQKoALR3c4NH6vrsX9h1QmD+Uy2Ah0UGz8TayO+UAF4L1l3JqvCBcIq0AT8uRBJ6rasrutF/jkvgnoLQiZnWEUpt+i/wRD9eBtsdrXXvYSrLjGfniPdWC+6VH+8jD2IMLYCKgUy/fHOtFz/U7HQeE+CfagF8W2jEHNmPuv5Awb4RfoPhUj/diedXdYJuKbPtsyTOZl7w22kHz+70mUdX2OR+ldefXbrCnggc+vJmrz/W3HeC8tFCEKKZXedDkJEF0GKg+/dQEp7sJtp6s92awBnXBXDR1hmnAZ5OqxdZsUJfS83gfQuH83iF/n3HUeembnPablVvtc5xBT3Wp3nYOipyMzkv78kXlKbfH73FHFx4FpROKE/y1nbI6YGcH0N2akA+HqKRA6BlUL3oanzyuG7i/C0di89asI75xGhdFA+R1+tiBpNV3vcCWHUU46yuBobB3w+sl/CB6RzRgGhrEd4Ojp210rGLwwYO/VV+C7R/RnJNZNpc/y28SX+he0EOfV/lTPqhN4nvhvueW510ijz1R3tcBOws5s+TEV2vYuKeTwCdlwzRG8n78JCiDxm5/BXWBe+7Ffhnkdd43VBUpJKpJuEYNToG44YFWG+LYnSla9umTgAdmXgc1sHaIKGL7augKujlQccOhUT5cBkrVWif8ER4iw5Ddw5FfqvBj8JVdB4GGvvO33i37RQ5aV/2AThGH20bo40/SZ0dS6yU6wLamsCKPgL74NhuDfsvacp0BoX2TdfzfXPa+I3rI7Bu/2PUagEENLanong/yRmMHBuwdE7rZnj3KntsvgTHSB+aTuz3SsTQHefcWBIJ+V/R6e2kDk8v3muSmeDkofNrduSGajZp4dQft96Kd7oNkpl6YUbsg+AUvaoOXte2JPaJVHLoPtdFTHCyF0DFw14Xjl/DVVT7yQrABX8BpBOfioyMBq2zg7/lh3EymCfkTgRs/V8Dd1P9VS5OWzuC7gTrJUxb0n+VrkeP/eAJ2U8k7grwbLgL+j0gOj2wUdsxrvInhr65kqLNqjD61JPY+1PJobuqi/jg1FoALSZ+2uqoIh3heab5VJXYLpgLIIkvBX8WfhJ26Xc09qjqeBM9uO+Er6jji/3y8GNwjDr7Gk5uXiSyLawPvku6FrAdc3Poyo6Yq8DHwdoU74q0yH8S1vc6OyPw9PYyRZ08YjZNmMT2SSWH7p6m2K4fOI0WQGHguyIc+uYX4iHKOiWAx6RZALVIzIrwRcgvge+CRfpKl+4AvgC/Gu59v4cY68GPw7UfofDZGU7RRD/66Nscu8Pfge9JJZqp0x1ip4uH+wdUVSf2prCeCq6C29KdAGxcFTNHD84NFcmsnYPTlw257VeR33VdxCZG4wXQ4oOhv/0qOtPsYyUAk2YBVGemxhKdSDl5LQrry9lvh1dqyCfgFyMtrCtMZB9jsclrQ/hQ+HK4Lu0Zw50IOclPg/eG9fZYe7B16EdtcyaYLgwpmuhH4KqD/J0c0WEAWi+A+izA2RjW306KHkQZvbCgW7gAVk1sBkkfmB6JFmvJ2p+IUa1H66qc+9TTgWXhz8CpR3vrZ+XLoj5zzcEm0T3hGy3hRHl2Dl7MBty9EthSjfsWgpsr8T9Wkd/+rn3TOjE6WQAVHyy9lNQTYhUdHMoXp4ULYGhgTMYAHQD/1NptSnBWg/09S0QDOrEN/kT4krnuqv4w6MFoRef0Fogzeho/cj1ytAtDkre0GWeQLhtCG258qA12W19SOX04naFW6Bxmo5CgdrYAWgJg6qxiFWlLZGhrhvbCBdAG0S8ZnOfDD8DZb5V8DL8N1hvgFC2o3254baJTb/LHYTK36YeO29wa6c+P2+QOpl7e2V62H+KMNthtfUkm9XKhs4PzxOl8AVTfwdXndhOcoqdQvtzGivq4LoAL0p2Avjf7M3gXTqXrl4M7IbC+D9AXE2C6Cvf6M0iJ2I1V9Et7ZO+NADwVkU9KMX15iMT04uOxQIKt+gK2MLXXF8LZgc++l599CvRjSERcLXCrDAnnN3Yk7yvnNydnTZ8brJ8wOzKRodagWfT35IRNfyoCp2jSvAQhyTPg4L5BF6MDduqx8bouYow3Bn3SkRSfnkYwbj+22WWfyft8vzO0P9JFDHCmw6E91EO6wK+LQS4/gUO0fV2sKnuCnAYXvwdYZdtUD/5z4aqjUfdicw18dNM4vh9YU+Eo6TY1RZNiASTB98Hn+J3rsg2+zjPNhWN0UpfxxgOLjqwZ6MwnxyN2HzHoi7+5/pcu44C/BHypN2ZaFHv/hpDbD+Lt6uWg5i3wNNeuqzq4vTwCh/Ij1g/gKlq4ANrgMVI69nE3vITJ+iqJoTOMKdq3TWyAd4N7Xcjd/Ij1aa8z33b1berg6iiS/ij1qza9E3HWh126j8byfQQGd3c3EPU74KHN+j7iCpM4m3ix1fxAX/HKmOO2AJbxdqJPehKJ0cIFsBwofedQG8GdHHzNmUTEOjb2qSDXh6b/3as24ae+2KFmPW73+n1e8LeDXerkUdE6DrCdo9Qm9hYm76MEX0crboKNfkel9wWJGDMsIKUWwdX66J9hgr8zrPE0OtR0fZYEG9cFUH0h5hQ4djB+4QJYDpJul4d+3qrPiWDYxEwdjdDbSG3c1iJ8ZsI+va0WSKYxQY5wAqkvnf7oK3ibO/hWPY9K5z/wCuYLYX0VTqRyq8xh6MyMmLoj1B2n6Htw7c8/lQx402B9dVGkfbBxPatJvHFfAG08iP0h2KeFCyAjciBc+dUZG8guS+LqYPGjcIxOaRIPMN3JvBW+zgM+hfaaTTDNB3/9EX29xJ1Dub/p+iqJsQGsi5R713I97V3bxgRjH9h+LEKb9OP6s/Sx/MljK1h38FoQ3wI3WgzxWxo+CtbY3Q6/LhazbzmxJ2wBVN+Ir/O49nREdfxegugP8u2JAf4er7HH/QchyUl3EnvDpxF/biK/3lTk8ALAU49255Nb7Acrs/MizgoYa/K/Ft4aVvt++Cr4Glgb/XPgh+HH4eVg2awIbwn/K3w1/L/w18jpNsoJIfqix3r9+Owe8CtgjaGOl/wJVl/0Nv1eWH0R6zyn+iJeH9bC+QR8LqzP/gLKSU30eToJ6rvjr4Q3gDUGd5Wsz02f08rwKrBeptwIXwSrj7PpY+j4DarxI/qwLdGeIJdLxy/qaCTy+AZSXbiPIZdOHv/LOam1JEj/Dw5b/cNCFcHhAAAAAElFTkSuQmCC"/></div></div></div>` +
        content.getElementsByClassName("printable")[0].innerHTML;

      content.querySelectorAll(".no-print").forEach(function (e) {
        e.style.display = "none";
      });

      content.getElementsByClassName("specifications")[0].style.marginTop = "580px";
      content.querySelectorAll(".custom-margin").forEach(function (e) {
        e.style.marginTop = "80px";
      });
      content.querySelector("#price_asterisc").style.marginTop = "-50px";
      content.querySelector("#social-info").style.marginTop = "200px";

      // nasconde temporaneamente l'imager per visualizzare l'anteprima immagine
      // content.querySelector('#cmp_imager').style.display = 'none';
      content.querySelector("#bike_image_pdf").style.display = "block";

      if (this.isPDFDownload == true) {
        this.isPDFDownload = false;

        await html2pdf()
          .set(options)
          .from(content)
          .toPdf()
          .get("pdf")
          .then((pdf) => {
            const totalPages = pdf.internal.getNumberOfPages();
          })
          .save();
      } else {
        await html2pdf()
          .set(options)
          .from(content)
          .toPdf()
          .get("pdf")
          .then((pdf) => {
            const totalPages = pdf.internal.getNumberOfPages();
          })
          .outputPdf("blob")
          .then((result) => {
            this.configPDF = result;
          });
      }
      this.showLoader = false;
      this.confirmDisabled = true;
    },
    pdfHasGenerated: function ($event) {
      this.configPDF = $event;
      document.querySelectorAll(".no-print").forEach(function (e) {
        e.removeAttribute("style");
      });
      this.showLoader = false;
    },
    onPdfProgress: function ($event) {
      if ($event >= 70 && $event < 100) {
        document.querySelectorAll(".no-print").forEach(function (e) {
          e.style.display = "none";
        });
      }

      if ($event == 100) {
        this.confirmDisabled = false;
      }
    },
    confirmConfiguration: function () {
      this.$root.$emit("bv::show::modal", "buy-modal");
    },
    backToConfigurator: function () {
      this.currentPhase = "configuration";
      this.currentSubPhase = 0;
      this.currentBaseStep = 0;
      window.scrollTo(0, 0);

      // per prevenire problemi di debug, il popup apparirà solo in produzione
      if (!window.mainSite.includes("pixelldemo")) {
        window.addEventListener("beforeunload", this.showAlert);
      }
    },
    configureAnotherBike: function () {
      // l'utente sta configurando un'altra bici,
      // viene rimossa la preconfigurazione corrente
      window.localStorage.removeItem("preconfiguration-stored");

      this.bikeConfiguration = {};
      this.components = {};
      this.componentsConfig = {};
      this.componentsList = [];
      this.defaultConfigurations = [];
      this.electronicMode = false;
      this.isPDFDownload = false;
      this.results = this.results = this.getDefaultResults();
      this.relatedCrankset = null;
      this.configurationSteps = [
        "frame",
        "colour",
        "fork",
        "stem",
        "bars",
        "groupset",
        "cages-bottles",
        "seat-post",
        "seat-clamp",
        "saddle-and-tape",
        "wheels",
        "tyres",
      ];

      this.reRenderImager = false;
      this.currentBike = null;

      this.$nextTick(() => {
        // Adding the component back in
        this.reRenderImager = true;
      });

      this.currentPhase = "selection";
      this.currentSubPhase = 0;
      this.currentBaseStep = 0;
      window.scrollTo(0, 0);

      this.loadBikes();
    },
    backToSummary: function () {
      this.removeLoadParam();
      this.currentPhase = "summary";
      this.currentSubPhase = 0;
      window.scrollTo(0, 0);

      // l'update dell'imager del componente result deve essere fatto
      // dopo la visualizzazione della pagina, altrimenti l'update sarà
      // eseguito su quello corrente del componente base (configuratore)
      const self = this;
      setTimeout(function () {
        self.loadBikeConfig();
      }, 600);

      window.removeEventListener("beforeunload", this.showAlert);
    },
    goToPreconfigured: function () {
      this.currentPhase = "selection";
      this.currentSubPhase = 1;
      window.scrollTo(0, 0);
    },
    loadConfigurations: function () {
      if (this.loginEmail == "" || this.loginEmail == null) {
        //console.log("no email setted");
        return [];
      }

      this.loginRes = "";
      axios
        .get("/api/mtm-configurator/configurations/load/" + this.loginEmail)
        .then((res) => {
          this.loggedUserConfigurations = res.data;
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.data.error);
          }
        });
    },
    loadConfiguration: function (id) {
      api.get("/api/mtm-configurator/configuration/" + id).then((res) => {
        let parsed = null;

        /*
        if (
          res.data.data != "undefined" &&
          typeof res.data.data.image != "undefined"
        ) {
          this.bikeImage = "/storage/" + res.data.data.image;
        }*/

        if (
          typeof res.data.data != "undefined" &&
          typeof res.data.data.data != "undefined"
        ) {
          if (typeof res.data.data.data == "object") {
            parsed = res.data.data.data;
          } else if (typeof res.data.data.data == "string") {
            try {
              parsed = JSON.parse(res.data.data.data);
            } catch (error) {
              console.error("CANT PARSE CONFIGURATION", res.data.data.data);
              this.setError("Can't load configuration");
              return false;
            }
          } else {
            console.error("UNDEFINED data TYPE", res.data.data.data);
            this.setError("Can't load configuration");
            return false;
          }

          if (parsed == null) {
            return false;
          }

          this.currentBike = parsed.currentBike;
          this.measures = parsed.measures;
          this.price = parsed.price;

          if (parsed.questionAnswers !== undefined) {
            this.questionAnswers = parsed.questionAnswers;
          }

          // l'utente avrà ricaricato la pagina, prende il questionario dalla memoria locale
          if (this.questionAnswers.length === undefined) {
            let qa = window.localStorage.getItem("questionAnswers");
            if (qa !== null) {
              this.questionAnswers = JSON.parse(qa);
            }
          }

          this.results = parsed.results;
          this.loadedFromDb = true;

          let parent = this;
          setTimeout(function () {
            parent.currentPhase = "summary";
            parent.currentSubPhase = 0;
          }, 1000);

          const self = this;
          setTimeout(function () {
            self.generateBikePng();
          }, 2000);

          // se l'id della preconfigurazione è diverso dalla scelta effettuata dall'utente
          // la configurazione memorizzata in locale viene sovrascritta
          let currentConfigId = window.localStorage.getItem("preconfiguration-stored");

          if (currentConfigId != id) {
            let jsonConfigData = res.data.configuration;
            window.localStorage.setItem("currentBikeConfig", jsonConfigData);
          }

          // carica un'eventuale configurazione memorizzata sul browser
          let currentBikeConfig = window.localStorage.getItem("currentBikeConfig");

          if (currentBikeConfig !== null) {
            // setta tutti i valori precedentemente scelti per la bici
            const self = this;
            setTimeout(function () {
              self.loadBikeConfig();
            }, 600);
          } else {
            // crea un nuovo oggetto per poter memorizzare i valori
            window.localStorage.setItem("currentBikeConfig", JSON.stringify({}));
          }
        }
      });
    },
    login: function () {
      this.loginRes = "";
      let parent = this;
      axios
        .post("/api/customer/login", {
          email: this.loginEmail,
          password: this.loginPassword,
        })
        .then((res) => {
          this.loggedUser = res.data.data;
          //this.loadConfigurations(this.loggedUser.id);
          setTimeout(function () {
            parent.$emit("bv::hide::modal", "login-modal");
          }, 1000);
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.data.error);
            this.loginRes = error.response.data.error;
          }
        });
    },
    logout: function () {
      this.loggedUserConfigurations = [];
      this.loggedUser = null;
      localStorage.loggedUser = null;
    },
    resetConfigurator: function () {
      this.currentPhase = "selection";
      this.currentSubPhase = 0;

      this.results = this.getDefaultResults();
    },
    getComponentById(id) {
      for (const [key, obj] of Object.entries(this.components)) {
        if (key != "frame" && key != "colour") {
          if (Array.isArray(obj[0])) {
            for (let i = 0; i < obj[0].length; i++) {
              let e = obj[0][i];
              if (e.id == id) {
                return e;
              }
            }
          }
        }
      }
      return null;
    },
    editComponent: function (type) {
      this.currentPhase = "configuration";
      this.currentSubPhase = 0;

      if (type == "colours") {
        this.currentBaseStep = 1;
      } else if (type == "fork") {
        this.currentBaseStep = 2;
      } else if (type == "stem") {
        this.currentBaseStep = 3;
      } else if (type == "handlebars") {
        this.currentBaseStep = 4;
      } else if (type == "groupset") {
        this.currentBaseStep = 5;
      } else if (type == "crankset") {
        this.currentBaseStep = 5;
      } else if (type == "cagebottle") {
        this.currentBaseStep = 6;
      } else if (type == "saddle") {
        this.currentBaseStep = 7;
      } else if (type == "wheels") {
        this.currentBaseStep = 8;
      } else if (type == "tyres") {
        this.currentBaseStep = 9;
      } else {
        this.currentBaseStep = 0;
      }
      window.scrollTo(0, 0);
    },
    incrementBaseStep: function () {
      this.currentBaseStep++;
    },
    decrementBaseStep: function () {
      this.currentBaseStep--;
    },
    setBaseStep: function (i) {
      this.currentBaseStep = i;
    },
    getDefaultResults: function () {
      return {
        frame: {
          finish: null,
          title: {
            family: null,
            text: null,
          },
        },
        colour: {
          type: null,
          primaryColor: null,
          secondaryColor: null,
        },
        fork: null,
        stem: null,
        handlebars: null,
        bartape: null,
        groupset: null,
        crankset: null,
        rings: null,
        cassette: null,
        cagebottle: null,
        seatpost: null,
        seatclamp: null,
        saddle: null,
        wheels: null,
        tyres: null,
        cabling: null,
      };
    },
    addToCart: function () {},
    showAlert(event) {
      event.preventDefault();
      const message =
        "Attention! If you reload the page you will lose all changes, are you sure?";
      event.returnValue = message;
      return message;
    },
    getCurrentConfig: function () {
      let currentBikeConfig = window.localStorage.getItem("currentBikeConfig");
      return JSON.parse(currentBikeConfig);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.passoni-logo {
  max-width: 170px;
}

select {
  color: #000000;
}

@media (max-width: 767px) {
  .menu-area {
    width: auto !important;
  }

  .header-configure-another-bike {
    display: none;
  }
}
</style>
